import {
  discordSocial,
  facebookSocial,
  logo,
  instagramSocial,
  waves,
  xSocial,
  telegram,
} from "@/constants";
import { Link } from "react-router-dom";

type FooterLink = {
  title: string;
  url: string;
};

const platformLinks: FooterLink[] = [
  {
    title: "Support",
    url: "/support",
  },
  {
    title: "FAQ",
    url: "/faq",
  },
  {
    title: "Glossary",
    url: "/glossary",
  },
  {
    title: "Partnership Program",
    url: "/partnership-program",
  },
  {
    title: "Whitepaper",
    url: "https://www.whitepaper.sharkroll.io/",
  },
];

const supportLinks = [
  // {
  //   title: "Help Center",
  //   url: "/help-center",
  // },
  {
    title: "AML Policy",
    url: "/aml-policy",
  },
  {
    title: "Terms and Conditions",
    url: "/toc",
  },
  {
    title: "Responsible Gaming",
    url: "/responsible-gambling",
  },
  {
    title: "Self-Exclusion",
    url: "/self-exclusion",
  },
  {
    title: "KYC Policy",
    url: "/kyc-policy",
  },
  {
    title: "Crypto Policy",
    url: "/coin-mixing-policy",
  },
];

type SocialLink = {
  icon: string;
  title: string;
  url: string;
};

const socialLinks: SocialLink[] = [
  // {
  //   icon: facebookSocial,
  //   title: "Facebook",
  //   url: "/",
  // },
  {
    icon: telegram,
    title: "Telegram",
    url: "https://t.me/sharkroll",
  },
  {
    icon: instagramSocial,
    title: "Instagram",
    url: "https://www.instagram.com/sharkrollcasino",
  },
  // {
  //   icon: discordSocial,
  //   title: "Discord",
  //   url: "https://discord.com/invite/sharkroll",
  // },
  {
    icon: xSocial,
    title: "X",
    url: "https://x.com/SharkrollCasino",
  },
];

const Footer = () => {
  return (
    <div className="relative flex flex-col gap-10 overflow-hidden border-t border-white/10 bg-[#020012] p-4 md:flex-row md:justify-between md:p-12">
      <div className="z-[2] col-span-6 md:w-1/2 lg:pr-4">
        <img src={logo} alt="logo" className="mb-2.5 w-32" />
        <p className="text-justify text-[12px] leading-5 text-[#ffffff]/30 md:text-start">
          The website{" "}
          <a className="text-[#ffffff]/30" href="https://sharkroll.io">
            www.casino.sharkroll.io
          </a>{" "}
          is owned and operated by Aurora Aces S.R.L., a company registered
          under number 3-102-913639, with the registered address: Province 01,
          San José, Canton 02, Escazú, San Rafael, 300 meters north of La Paco
          Shopping Center, Plaza Florencia, Unit Ten, Postal Code 10203. Aurora
          Aces S.R.L. holds a full duty license under registered number 924907,
          in accordance with the ‘servicio de enlace de llamadas y casas de
          apuestas electrónicas,’ issued by the Government of the Republic of
          Costa Rica.
          <br />
          <br />
          Gambling can be addictive. Play responsibly.
        </p>
      </div>

      <div className="flex flex-col gap-4 md:w-3/4 md:flex-row md:justify-end md:gap-8">
        <div className="flex justify-between md:justify-start md:gap-8">
          <div>
            <h3 className="mb-4 text-xs font-bold uppercase text-white">
              Platform
            </h3>
            <ul className="flex flex-col gap-2">
              {platformLinks.map((link) => (
                <li
                  key={link.title}
                  className="text-[12px] font-medium leading-[22px] text-white opacity-30"
                >
                  <Link
                    to={link.url}
                    target={link.title === "Whitepaper" ? "_blank" : ""}
                  >
                    {link.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="mb-4 text-nowrap text-xs font-bold uppercase text-white">
              Support and Legal
            </h3>
            <ul className="flex flex-col gap-2">
              {supportLinks.map((link) => (
                <li
                  key={link.title}
                  className="text-[12px] font-medium leading-[22px] text-white opacity-30"
                >
                  <Link to={link.url}>{link.title}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div>
          <h3 className="mb-4 text-xs font-bold uppercase text-white">
            Social
          </h3>
          <ul className="flex flex-row justify-around gap-3 lg:flex-col">
            {socialLinks.map((link) => (
              <li
                key={link.title}
                className="text-[12px] font-medium leading-[22px] text-white opacity-30"
              >
                <Link to={link.url}>
                  <div className="flex items-center gap-2">
                    <img
                      src={link.icon}
                      alt={link.title}
                      className="max-h-6 w-5"
                    />
                    {link.title}
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;
